"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToolbarDividerStyles_unstable", {
    enumerable: true,
    get: ()=>useToolbarDividerStyles_unstable
});
const _react = require("@griffel/react");
const _reactDivider = require("@fluentui/react-divider");
const useBaseStyles = /*#__PURE__*/ (0, _react["__styles"])({
    root: {
        mc9l5x: "ftuwxu6",
        B2u0y6b: "f1lwjmbk"
    },
    vertical: {
        B2u0y6b: "fe668z"
    }
}, {
    d: [
        ".ftuwxu6{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;}",
        ".f1lwjmbk{max-width:1px;}",
        ".fe668z{max-width:initial;}"
    ]
});
const useToolbarDividerStyles_unstable = (state)=>{
    (0, _reactDivider.useDividerStyles_unstable)(state);
    const { vertical  } = state;
    const toolbarDividerStyles = useBaseStyles();
    state.root.className = (0, _react.mergeClasses)(state.root.className, toolbarDividerStyles.root, !vertical && toolbarDividerStyles.vertical);
    return state;
}; //# sourceMappingURL=useToolbarDividerStyles.js.map

//# sourceMappingURL=useToolbarDividerStyles.js.map